import jwtDecode, { JwtPayload } from 'jwt-decode'
import { JWT_TOKEN, TOKEN_REFRESH_FALLBACK_MS, TOKEN_REFRESH_REMAINING_FRACTION } from 'lib/constants'

// Kept free of `models` imports so the axios interceptors can use it:
// lib/utils/auth pulls in the model layer, which imports models/api/rest back.

function claims(token?: string | null): JwtPayload | null {
  const jwt = token ?? localStorage.getItem(JWT_TOKEN)
  if (!jwt) return null
  try {
    return jwtDecode<JwtPayload>(jwt)
  } catch (e) {
    return null
  }
}

export function getTokenExpiresAt(token?: string | null): number | null {
  const exp = claims(token)?.exp
  return exp ? exp * 1000 : null
}

// The token's full validity span, which the API sets per environment.
export function getTokenLifetimeMs(token?: string | null): number | null {
  const { exp, iat } = claims(token) || {}
  if (!exp || !iat || exp <= iat) return null
  return (exp - iat) * 1000
}

// True once the token is inside the last slice of its own lifetime, so the same
// rule holds for a one-hour dev token and a thirty-day one. False when there is
// no token or no readable `exp` — nothing to pre-emptively renew, so those take
// the normal 401 path instead.
export function isTokenNearingExpiry(token?: string | null): boolean {
  const expiresAt = getTokenExpiresAt(token)
  if (expiresAt === null) return false

  const remaining = expiresAt - Date.now()
  if (remaining <= 0) return true

  const lifetime = getTokenLifetimeMs(token)
  if (lifetime === null) return remaining < TOKEN_REFRESH_FALLBACK_MS

  return remaining < lifetime * TOKEN_REFRESH_REMAINING_FRACTION
}
